// extracted by mini-css-extract-plugin
module.exports = {"decor":"styles_decor__cMfHs","icon":"styles_icon__yZ9u2"};